module.exports = __webpack_public_path__ + "static/forecast/fresh-snow/shin-b47a29b0d67d7da179d3820ac05aeab8.svg";